// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// 引入element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
// 引入路由
import router from "./router";
// 引入状态管理
import store from "./vuex/store";
// 引入icon
import "./assets/icon/iconfont.css";
//

// 引入echarts
import echarts from "echarts";

// 树形下拉
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("Treeselect", Treeselect);
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from "./utils/util";
for (let index in custom) {
  Vue.prototype[index] = custom[index];
}
Vue.directive("hasPermi", {
  inserted: function (el, binding, vnode) {
    const { value } = binding;
    const all_permission = "*:*:*";
    const permissions = JSON.parse(
      localStorage.getItem("userInfo")
    ).permissions;
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;

      const hasPermissions = permissions.some((permission) => {
        return (
          all_permission === permission || permissionFlag.includes(permission)
        );
      });

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(`请设置操作权限标签值`);
    }
  },
});

// 复制
Vue.directive("copy", {
  bind: function (el, binding) {
    el.$copy = function () {
      const textarea = document.createElement("textarea");
      textarea.value = binding.value;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("Copy");
      document.body.removeChild(textarea);
    };
    el.addEventListener("click", el.$copy);
  },
  unbind: function (el) {
    el.removeEventListener("click", el.$copy);
  },
});

const whiteList = ["/login", "/auth-redirect", "/bind", "/register"];
// 路由拦截器
router.beforeEach((to, from, next) => {
  if (to.query.token || localStorage.getItem("token")) {
    if (to.path === "/") {
      next({ path: `/home` });
    } else {
      if (store.state.rewriteRoutes.length === 0) {
        store.dispatch("getRouters").then((accessRoutes) => {
          console.log(accessRoutes, "accessRoutes");
          router.addRoutes(accessRoutes);
          next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
        });
      } else {
        next();
      }
    }
  } else {
    // 没有token;
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      window.open(`https://www.appbyt.com/pcPage.html`);
    }
  }

  // if (localStorage.getItem("token")) {
  //   if (to.path === "/") {
  //     next({ path: `/login` });
  //   } else {
  //     if (store.state.rewriteRoutes.length === 0) {
  //       store.dispatch("getRouters").then((accessRoutes) => {
  //         console.log(accessRoutes, "accessRoutes");
  //         router.addRoutes(accessRoutes);
  //         next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
  //       });
  //     } else {
  //       next();
  //     }
  //   }
  // } else {
  //   // 没有token;
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     // 在免登录白名单，直接进入
  //     next();
  //   } else {
  //     next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
  //   }
  // }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store, //使用store vuex状态管理
  components: {
    App,
  },
  template: "<App/>",
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue(),
  },
});



// WEBPACK FOOTER //
// ./src/main.js